import ExtendedError from './type/Extended';

type T = (error: ExtendedError) => string;

const f: T = (error) => {
    const messages = [];

    switch (error.status) {
        case 400:
        case 404:
            messages.push('This link may have been removed.');
            break;
        default:
            messages.push('An unexpected error occurred.');
            break;
    }

    messages.push('Please contact your IT administrator.');

    return messages.join(' ');
};

export default f;
